export { NewsPage as default } from '@/components/enpages/Ir/News'
